import { render, staticRenderFns } from "./PendingUsers.vue?vue&type=template&id=99f1e9c6&scoped=true"
import script from "./PendingUsers.vue?vue&type=script&lang=js"
export * from "./PendingUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f1e9c6",
  null
  
)

export default component.exports